"use client";
import React from "react";
import Image from "next/image";
import styles from "./client.module.scss";
import { toWebp } from "@/utils/common";
import Link from "next/link";

interface Props {
  data: any;
}
const RequestProposalSolution: React.FC<Props> = ({ data }) => {
  const url = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

  return (
    <section
      className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white
  before:content-[''] before:absolute before:h-[450px] 2xl:before:h-[600px] xl:before:h-[500px] md:before:h-[400px] sm:before:h-[400px] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10"
    >
      <div className="container">
        <div className="heading mb-[40px] lg:mb-[40px] xl:mb-[40px]">
          <h2 className="font-bold text-primary-text text-heading-1 text-center">
            {data.title}
          </h2>
          <p className="text-[#32343B] text-[20px] leading-[26px] xl:text-[24px] xl:leading-[31.1px] text-center">
            {data.short_title}
          </p>
        </div>
        {data?.Projects?.map(
          (item: any, i: number) =>
            item?.link?.href && (
              <div
                key={"Projects" + i}
                className="bg-white p-[48px_16px] md:p-[24px_24px] border-[#B0D9F7] border-[1px] group md:mb-[30px] mb-[20px]"
              >
                <div className="grid grid-cols-1 xl:grid-cols-[60%_auto] 2xl:grid-cols-[70%_auto] mb-[24px] lg:mb-[32px] lg:gap-[16px]">
                  <div>
                    <h2 className="text-[#040405] font-[700] text-[28px] lg:text-[32px] xl:text-[36px] leading-[36px] lg:leading-[46.6px] xl:leading-[46.8px] mb-[20px] tracking-[1px]">
                      {item.Title}
                    </h2>
                  </div>
                  <div className="flex justify-center xl:justify-end gap-[16px] xl:gap-[30px] ">
                    {item?.key_points?.map((project: any, i: number) => (
                      <React.Fragment key={i}>
                        {(i + 1) % 2 !== 0 ? (
                          <div
                            key={"project-" + i + "-key-points"}
                            className="p-[20px_12px] bg-[#E6F3FD] h-full flex flex-col w-full max-w-[100%] xl:max-w-[153px]"
                          >
                            <p className="text-[14px] leading-[19.8px] xl:text-[16px] xl:leading-[22px] font-[400] text-[#000000] mb-[16px]">
                              {project.title}
                            </p>
                            <h5 className="font-[600] text-[22px] leading-[28.6px] lg:text-[24px] lg:leading-[31.6px] xl:text-[32px] xl:leading-[41.6px] text-[#000000]">
                              {project.numbers}
                            </h5>
                          </div>
                        ) : (
                          <div className="p-[20px_12px] bg-[#F3F8E6] h-full flex flex-col w-full max-w-[100%] xl:max-w-[153px]">
                            <p className="text-[14px] leading-[19.8px] xl:text-[16px] xl:leading-[22px] font-[400] text-[#000000] mb-[16px]">
                              {project.title}
                            </p>
                            <h5 className="font-[600] text-[22px] leading-[28.6px] lg:text-[24px] lg:leading-[31.6px] xl:text-[32px] xl:leading-[41.6px] text-[#000000]">
                              {project.numbers}
                            </h5>
                            <span
                              className="block text-[14px] leading-[19.8px] xl:text-[16px] xl:leading-[22px] font-[400] text-[#000000]"
                              dangerouslySetInnerHTML={{
                                __html: project.description,
                              }}
                            />
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
                <div className="mb-[24px] lg:mb-[32px] relative">
                  {item?.Snapshots?.data?.attributes?.url && (
                    <Link
                      href={item?.link?.href}
                      className="block"
                      onClick={(e) => {
                        if (item?.link?.href?.length < 2) e.preventDefault();
                      }}
                    >
                      <Image
                        src={toWebp(
                          url + item?.Snapshots?.data?.attributes?.url,
                        )}
                        alt="image"
                        width={1182}
                        height={360}
                        className="w-full h-[360px] md:h-[420px] xl:h-[360px] block object-cover"
                      />
                    </Link>
                  )}
                  {item?.technologies?.map((tech: any, i: number) => (
                    <div
                      key={"tech-" + i}
                      className="absolute w-full left-0 bottom-0 px-[0px] pt-[20px] md:p-[20px_25px] bg-[linear-gradient(180deg,rgba(176,217,247,0.3)_0%,#0086E680_100%)] backdrop-blur-[10px] xl:opacity-0 xl:group-hover:opacity-100 transition-opacity duration-300 overflow-hidden"
                    >
                      <div className="flex justify-between items-center md:flex-row flex-col gap-[20px]">
                        <p className="text-white  font-[600] text-[16px] leading-[22.2px]">
                          {tech.title}
                        </p>
                        <div
                          className={`mb-[10px] sm:mb-[0px] w-[100%] sm:w-[40%] xl:w-[20%] ${styles.marque}`}
                        >
                          <div className={` ${styles.marqueTrack}`}>
                            {tech?.technologies?.map(
                              (stack: any, i: number) => (
                                <div
                                  key={"stack-" + i}
                                  className={` ${styles.marqueInner}`}
                                >
                                  {stack?.image?.data?.attributes?.url ? (
                                    <Image
                                      width={42}
                                      height={42}
                                      src={toWebp(
                                        url +
                                          stack?.image?.data?.attributes?.url,
                                      )}
                                      alt={stack?.image?.data?.attributes?.name}
                                      className="w-[32px] h-[32px] block object-cover"
                                      quality={100}
                                    />
                                  ) : (
                                    <div className="w-[32px] h-[32px] bg-[#E6EAF0]" />
                                  )}
                                </div>
                              ),
                            )}
                            {/* duplicate once */}
                            {tech?.technologies?.map(
                              (stack: any, i: number) => (
                                <div
                                  key={"stack-" + i}
                                  className={` ${styles.marqueInner}`}
                                >
                                  {stack?.image?.data?.attributes?.url ? (
                                    <Image
                                      width={42}
                                      height={42}
                                      src={toWebp(
                                        url +
                                          stack?.image?.data?.attributes?.url,
                                      )}
                                      alt={stack?.image?.data?.attributes?.name}
                                      className="w-[32px] h-[32px] block object-cover"
                                      quality={100}
                                    />
                                  ) : (
                                    <div className="w-[32px] h-[32px] bg-[#E6EAF0]" />
                                  )}
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <p className="text-[#040405] font-[400] text-[16px] leading-[24.4px] xl:text-[20px] xl:leading-[28px]">
                  {item.Description}
                </p>
              </div>
            ),
        )}
      </div>
    </section>
  );
};

export default RequestProposalSolution;
